import axios from '../config/axios';

export function apiAddHash(id) {
  return axios.post(`blockchain/certificate/add-hash/${id}`);
}

export function apiHasHash(id) {
  return axios.get(`blockchain/certificate/has-hash/${id}`);
}
